// The pill-shaped view switcher the timetable surfaces use for "show me this
// cut of the same data".
//
// It existed three times — the board's class/teacher/subject switch and the
// live grid's axis and density switches — each with the same ~200-character
// class string, and they had already drifted (`transition` vs
// `transition-colors`, `bg-indigo-600` vs `bg-slate-800` for the active state,
// three different paddings on one toolbar). Two identical-looking controls with
// different active fills imply a rank difference that does not exist.
//
// `aria-pressed` rather than a radiogroup: these are toggle buttons that act
// immediately, not a form value to be submitted.
export default function SegmentedControl({
  options,
  value,
  onChange,
  ariaLabel,
  renderLabel,
  disabled = false,
}) {
  return (
    <div
      role="group"
      aria-label={ariaLabel}
      className="inline-flex flex-wrap rounded-xl border border-slate-200 bg-white p-1 shadow-sm"
    >
      {options.map((option) => {
        const active = option === value;
        return (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            aria-pressed={active}
            disabled={disabled}
            className={`px-4 py-1.5 rounded-lg text-[11px] font-black uppercase tracking-widest transition-colors disabled:opacity-60 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 ${
              active
                ? "bg-indigo-600 text-white shadow-sm"
                : "text-slate-500 hover:text-slate-800 hover:bg-slate-50"
            }`}
          >
            {renderLabel(option)}
          </button>
        );
      })}
    </div>
  );
}
